import { useNavigate } from 'react-router-dom';
import { images } from '../constants';

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(-1) || navigate('/')}
      className="w-8"
    >
      <img
        className="w-8 lg:mx-10 my-4 hover:scale-125 duration-100 focus:bg-transparent"
        src={images.backarrow}
        alt="Back"
      />
    </button>
  );
};
export default BackButton;
